var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGithubinline = function SvgGithubinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#141A1F",
    fillRule: "evenodd",
    d: "M14.065 1.118A13.212 13.212 0 0 0 1.012 12.21 13.202 13.202 0 0 0 9.89 26.857c.665.121.9-.292.9-.64V23.97c-3.69.802-4.468-1.776-4.468-1.776a3.534 3.534 0 0 0-1.468-1.937c-1.192-.81.097-.81.097-.81a2.781 2.781 0 0 1 2.02 1.361 2.821 2.821 0 0 0 3.843 1.103c.051-.667.339-1.294.811-1.767-2.935-.333-6.017-1.468-6.017-6.486a5.106 5.106 0 0 1 1.354-3.542 4.814 4.814 0 0 1 .13-3.494s1.111-.357 3.633 1.354a12.5 12.5 0 0 1 6.617 0c2.522-1.71 3.625-1.354 3.625-1.354a4.79 4.79 0 0 1 .162 3.47 5.106 5.106 0 0 1 1.354 3.542c0 5.075-3.09 6.185-6.033 6.485a3.12 3.12 0 0 1 .9 2.432v3.624c0 .43.235.762.908.632a13.21 13.21 0 0 0 8.732-14.61 13.205 13.205 0 0 0-12.924-11.08",
    clipRule: "evenodd"
  })));
};
export default SvgGithubinline;